import React, {useEffect, useState} from 'react'
import {AutoComplete, Button, Form, Input, InputNumber, Select} from "antd";
import {createWarehouseIncoming} from "../../services/serviceWarehouseIncoming";
import {getAllCompletedPurchases} from "../../services/servicePurchase";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {Option} = AutoComplete;
const {TextArea} = Input;
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
};

const WarehouseIncomingCreate = ({modalCloseSignal, warehouses}) => {
    const [form] = Form.useForm();
    const [purchaseData, setPurchaseData] = useState([]);
    const [, setSelectedPurchase] = useState();
    const [selectedStock, setSelectedStock] = useState();
    const [purchaseStocks, setPurchaseStocks] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState();
    const [loadings, setLoadings] = useState([]);


    useEffect(() => {
        getAllCompletedPurchases()
            .then(({data}) => {
                const purchaseComplete = []
                data.forEach(item => {
                    if (item.contentOfPurchaseList.length) {
                        purchaseComplete.push({
                            text: item.purchaseNumber,
                            value: item.id,
                            contentList: item.contentOfPurchaseList
                        })
                    }
                });
                setPurchaseData(purchaseComplete);
            })
    }, [])

    const handlePurchaseChange = (v, {key}) => {
        if (key) {
            const matchedPurchase = purchaseData.find(item => item.value === Number(key));
            const stocks = matchedPurchase.contentList.map((item, index) => {
                return {
                    value: `${item.stock.id}-${index}`,
                    key: `${item.stock.id}-${index}`,
                    contentId: item.id,
                    label: `${item.stock.code} - ${item.stock.name}`,
                    quantity: item.quantity
                }
            });
            setPurchaseStocks(stocks);
            setSelectedPurchase(key);
        } else {
            form.setFieldsValue({quantity: '', stock: ''});
        }
    };
    const handleStockChange = (v, option) => {
        if (v && option.contentId) {
            const keys = option.key.split('-');
            const stockId = keys[0];
            const matchedStock = purchaseStocks.find(item => item.contentId === option.contentId);
            form.setFieldsValue({
                quantity: matchedStock.quantity
            });

            setSelectedStock(stockId);
        } else {
            form.setFieldsValue({quantity: ''});
        }
    };
    const handleWarehouseChange = (v, {key}) => {
        if (key) setSelectedWarehouse(key)
    };
    const handleSubmit = (list) => {
        enterLoadingState(setLoadings);
        let requestObj = {
            incomingQuantity: list.quantity,
            purchase: {
                purchaseNumber: list.purchaseNumber,
            },
            warehouse: {
                id: selectedWarehouse
            },
            stock: {
                id: selectedStock
            },
            refund: list.refund,
            description: list.description
        };

        createWarehouseIncoming(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloseSignal()
            })
            .catch(() => exitLoadingState(setLoadings))
            .finally(() => exitLoadingState(setLoadings))
    };
    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
    };

    return (
        <React.Fragment>
                <Form
                    {...formLayout}
                    form={form}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                    labelAlign={"left"}
                >

                    <Form.Item
                        label={'Satın Alma No'}
                        name={'purchaseNumber'}
                        rules={[
                            {required: true, message: 'Lütfen Satın Alma Numarası Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handlePurchaseChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {
                                purchaseData.map(item => <Option key={item.value}
                                                                 value={item.text}>{item.text}</Option>)
                            }
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Ürün'}
                        name={'stock'}
                        rules={[
                            {required: true, message: 'Lütfen Ürün Seçini'}
                        ]}
                    >
                        <Select allowClear showSearch options={purchaseStocks} onChange={handleStockChange} filterOption={selectSearch}/>
                    </Form.Item>
                    <Form.Item
                        label={'Depo'}
                        name={'warehouse'}
                        rules={[
                            {required: true, message: 'Lütfen Depo Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleWarehouseChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {
                                warehouses.map(item => <Option key={item.value} value={item.text}/>)
                            }
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Miktar'}
                        name={'quantity'}
                        initialValue={1}
                        rules={[
                            {required: true, message: 'Miktar Alanı Boş Bırakılamaz'},
                            {type: "number", min: 1, message: 'Miktar Alanı En Az 1 Olmalı'}
                        ]}
                    >
                        <InputNumber min={0} step={0.1}/>
                    </Form.Item>
                    <Form.Item
                        label={'Satıştan İade'}
                        name={'refund'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Not'}
                        name={'description'}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loadings[0]}>Kaydet</Button>
                    </Form.Item>
                </Form>
        </React.Fragment>
    )
}
export default WarehouseIncomingCreate